import { Compass, Sprout, Users, Zap } from "lucide-react";
import { ETICHETTE } from "@/data/simulatorCopy";

const Col = ({ id, Icon, label, children }) => (
  <div className="rounded-xl border border-[#1e2024] bg-white/[0.02] p-4 sm:p-5" data-testid={`sim-col-${id}`}>
    <p className="flex items-center gap-2 text-[11px] font-semibold tracking-[0.2em] uppercase text-cyan">
      <Icon className="h-3.5 w-3.5 shrink-0" strokeWidth={2} /> {label}
    </p>
    <div className="mt-3 text-sm leading-relaxed text-white/85">{children}</div>
  </div>
);

const Bullets = ({ items }) => (
  <ul className="space-y-2">
    {items.map((t) => (
      <li key={t} className="flex gap-2">
        <span className="mt-[9px] h-1 w-1 shrink-0 rounded-full bg-[#00e5ff]" />
        <span>{t}</span>
      </li>
    ))}
  </ul>
);

export const ResultColumns = ({ archetype }) => (
  <div className="mt-8 grid gap-3 sm:grid-cols-2 lg:grid-cols-4" data-testid="sim-columns">
    <Col id="forza" Icon={Zap} label={ETICHETTE.forza}>
      <Bullets items={archetype.forza} />
    </Col>
    <Col id="sviluppo" Icon={Sprout} label={ETICHETTE.sviluppo}>
      <Bullets items={archetype.sviluppo} />
    </Col>
    <Col id="contesti" Icon={Compass} label={ETICHETTE.contesti}>
      <div className="flex flex-wrap gap-2">
        {archetype.contesti.map((c) => (
          <span key={c} className="rounded-full border border-[#00e5ff]/30 bg-[#00e5ff]/[0.06] px-3 py-1 text-xs text-white">{c}</span>
        ))}
      </div>
    </Col>
    <Col id="team" Icon={Users} label={ETICHETTE.team}>
      <p className="text-titanium">{archetype.team}</p>
    </Col>
  </div>
);
